module.exports = __webpack_public_path__ + "img/ic_read.66cd8d81.svg";